import { keyframes } from 'styled-components'

export default keyframes`
0% {
transform: translateX(-101%);
}
20% {
transform: translateX(0);
}
60% {
transform: translateX(0);
}
95% {
transform: translateX(101%);
}
100% {
transform: translateX(101%);
}
`
